import {
    useMutation,
    useQuery,
} from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Get, Put } from "../api";
import API_CONSTANTS from "../constants/api";
import { appendQueryParams } from "../helpers/queryHelper";;

export const useZoomAccounts = (params) => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["zoomAccounts", params],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.ZOOM_ACCOUNTS.base}?${appendQueryParams({ params })}`,
                token,
                toastError: true
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useZoomAccountsOptions = () => {
    const token = useSelector((state) => state.user?.token)
    return useQuery({
        queryKey: ["zoomAccountsOptions"],
        queryFn: async () => {
            const { data } = await Get({
                path: `${API_CONSTANTS.ZOOM_ACCOUNTS.getOptions}`,
                token,
                toastError: true,
            })
            return data
        },
        keepPreviousData: true
    })
}

export const useUpdateZoomAccount = (id) => {
    const token = useSelector((state) => state.user?.token)
    return useMutation({
        mutationFn: async (body) => {
            const { data } = await Put({
                path: `${API_CONSTANTS.ZOOM_ACCOUNTS.base}/${id}`,
                token,
                body,
                toastError: true,
                toastMessage: true
            })
            return data
        },
    })
}
